import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from 'app/core/auth/auth.module';
import { IconsModule } from 'app/core/icons/icons.module';
import { TranslocoCoreModule } from 'app/core/transloco/transloco.module';
import { LocalStorageService } from './services/localstorage.service';
import { LocalisationService } from './services/localisation/zuper.localisation.service';
import { DefaultDataService } from './services/default_data/default_data.service';
import { SessionExpiredService } from './services/session_expired/session_expired.service';
import { UtilityService } from './services/utility_functions/utility_functions.service';

@NgModule({
    imports: [
        AuthModule,
        IconsModule,
        TranslocoCoreModule,
        CommonModule,
    ],
    declarations:[],
    providers:[
        LocalStorageService,
        LocalisationService,
        SessionExpiredService,
        UtilityService,
        DefaultDataService
    ]
})
export class CoreModule
{
    /**
     * Constructor
     */
    constructor(
        @Optional() @SkipSelf() parentModule?: CoreModule
    )
    {
        // Do not allow multiple injections
        if ( parentModule )
        {
            throw new Error('CoreModule has already been loaded. Import this module in the AppModule only.');
        }
    }
}
